/**
 * CSR (Customer Service Representative) Thunks
 *
 * This module exports all async operations for the CSR app, organized by functionality:
 *
 * Customer Operations:
 * - searchCustomers: Search for customers by various fields
 * - loadCurrentlyAssistedCustomer: Load the customer currently being assisted
 * - startAssistingCustomer: Begin assisting a specific customer
 * - stopAssistingCustomer: End customer assistance session
 *
 * Basket Operations:
 * - lookupBasket: Find a basket by reference number
 * - loadCurrentlyAssistedBasket: Load the basket for the assisted customer
 * - freezeBasket: Freeze a basket to prevent modifications
 * - assignBasket: Assign a basket to a customer by email
 * - startNewBasket: Create a new basket (freezing the old one)
 *
 * Voucher Operations:
 * - searchVoucherCode: Search for vouchers by code
 * - deleteVoucherCode: Delete a voucher from the system
 *
 * Utility Operations:
 * - loadCountries: Load available countries for address forms
 */

// Customer Operations
export { searchCustomers } from "./searchCustomers";
export { loadCurrentlyAssistedCustomer } from "./loadCurrentlyAssistedCustomer";
export { startAssistingCustomer } from "./startAssistingCustomer";
export { stopAssistingCustomer } from "./stopAssistingCustomer";

// Basket Operations
export { lookupBasket } from "./lookupBasket";
export { loadCurrentlyAssistedBasket } from "./loadCurrentlyAssistedBasket";
export { assignBasket } from "./assignBasket";
export { startNewBasket } from "./startNewBasket";

// Voucher Operations
export { searchVoucherCode } from "./searchVoucherCode";
export { deleteVoucherCode } from "./deleteVoucherCode";

// Utility Operations
export { loadCountries } from "./loadCountries";
